export enum PlayerTeamInvitationTypeEnum {
  INVITE = 'INVITE',
  JOIN = 'JOIN',
}
